export class BaseConstants {
    public static baseUrl: string;
    public static appConfig: object;
    public static digitalSignageConfig: object;
    public static tokenEndPoint = 'oauth/token';
}
